/**
 * @desc 保存和编辑
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageNoticeUser.save.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageNoticeUser/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
